<template>

<div id="app" :class="{'is-mobile': is.mobile, 'is-tablet': is.tablet}">

<template v-if="!is.loading">

	<com-logo />

	<com-metrics :data="data" />

	<com-chart-syncs :data="data" :width="width" />

</template>

</div>

</template>

<script>

import axios from 'axios'
import Vue from 'vue'
import comLogo from './components/Logo'
import comMetrics from './components/Metrics'
import comChartSyncs from './components/ChartSyncs'
import _ from 'underscore'

export default {

	components: {
		'com-logo': comLogo,
		'com-metrics': comMetrics,
		'com-chart-syncs': comChartSyncs
	},

	data: function() {

		return {	
			is: {
				loading: true,
				mobile: false,
				tablet: false
			},
			width: 0,
			data: {}
		}

	},

	created: function() {

		window.addEventListener('resize', this.onResize.bind(this))

		this.load()

		this.onResize()

	},

	methods: {

		onResize: function() {

			this.width = window.innerWidth

			this.is.mobile = this.width < 1000
			this.is.tablet = this.width >= 1000 && this.width < 1400

		},

		load: function() {

			axios.get('https://api.geekgroup.app/api/status.json', {
				headers: {
					'Cache-Control': 'no-cache',
					'Pragma': 'no-cache',
					'Expires': '0',
				}
			}).then(function(response) {

				Vue.set(this, 'data', response.data)

				this.is.loading = false

				_.delay(function() {

					this.load()

				}.bind(this), 1000)

			}.bind(this))

		}

	}
	
}

</script>

<style>

body {
	background-color: #082534;
}

#app {
	position: fixed;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	color: #fff;
}

#app.is-tablet {
	position: relative;
	left: auto;
	top: auto;
	right: auto;
	bottom: auto;
	min-height: 100vh;
}

#app.is-mobile {
	position: relative;
	left: auto;
	top: auto;
	right: auto;
	bottom: auto;
}

</style>
